import { takeLatest } from 'redux-saga'
import { select, call, put } from 'redux-saga/effects'
import { applyProjectsAction } from 'actions/projectActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { updateUiAction } from 'actions/uiActions'
import { CHANGE_PROJECT_FROM_STARTUP, CREATE_PROJECT_FROM_STARTUP } from 'actions/projectActionTypes'
import updateDocument from 'helpers/databases/updateDocument'
import reloadWindow from 'helpers/reloadWindow'
import createDocumentSaga from 'sagas/createDocumentSaga'
import initialProject from 'helpers/projects/initialProject'
import configDatabase from 'sagas/setupProjectsSaga/configDatabase'
import { getProjects } from 'sagas/setupProjectsSaga/findBySelector'
import { getMostRecentId } from 'sagas/setupProjectsSaga/mostRecentProject'

function * showModalAndExpandProject(projects) {
  yield put(applyProjectsAction(projects))
  yield put(updateUiAction({ modal: 'SetupProjectModal' }))
}

function * setupProjects(db) {
  const projects = yield call(getProjects, db)
  const { _id } = yield call(getMostRecentId, db)

  yield call(showModalAndExpandProject, projects.filter(p => p._id !== _id))
}

function * getDbIfNotAvailable(db) {
  if (db) return db
  else return yield call(configDatabase)
}

export default function * catchEarlyErrorsSaga(err) {
  try {
    yield put(notifyHoneybadgerAction(err, { type: 'CATCH_EARLY_EARLY_ERRORS_SAGA', skipThrow: true }))
    const { database, catchEarlyErrors } = yield select(s => s)
    const db = yield call(getDbIfNotAvailable, database)

    if (catchEarlyErrors) yield call(setupProjects, db)
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: 'CATCH_EARLY_EARLY_ERRORS_SAGA_SECONDARY', skipThrow: true }))
    yield put(updateUiAction({ modal: 'ProjectLoadModal' }))
  }
}

export function * changeProjectFromStartup(action) {
  try {
    const { database } = yield select(s => s)

    yield call(updateDocument, database, { _id: action.id, updatedAt: Date.now() })
    yield call(reloadWindow)
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: 'CATCH_EARLY_EARLY_ERRORS_SAGA_SECONDARY', skipThrow: true }))
    yield put(updateUiAction({ modal: 'ProjectLoadModal' }))
  }
}

export function * watchChangeProjectFromStartup() {
  yield * takeLatest(CHANGE_PROJECT_FROM_STARTUP, changeProjectFromStartup)
}

export function * createProjectFromStartup(action) {
  try {
    yield call(createDocumentSaga, Object.assign({}, initialProject()))
    yield call(reloadWindow)
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: 'CATCH_EARLY_EARLY_ERRORS_SAGA_SECONDARY', skipThrow: true }))
    yield put(updateUiAction({ modal: 'ProjectLoadModal' }))
  }
}

export function * watchCreateProjectFromStartup() {
  yield * takeLatest(CREATE_PROJECT_FROM_STARTUP, createProjectFromStartup)
}



// WEBPACK FOOTER //
// ./src/sagas/catchEarlyErrorsSaga.js